import React from 'react'

export default function ContactInfo() {
  return (
    <div className='d-flex flex-column align-items-center'>
      <h2 className='fs-1 mb-3 text-uppercase fw-bold'>Where To Find Us?</h2>
      <p className='mb-5'> Jubilee Hills, Hyderabad</p>
      <h3>Opening Hours</h3>
      <p className='m-0'>Mon - Fri: 07:00 - 22:00</p>
      <p>Sat - Sun: 08:00 - 23:00</p>
    </div>
  )
}
